import React from "react"
import Card from "../shared/Card"
import Styles from "./Kontogruppe.module.css"
import KontogruppeList from "./KontogruppeList"
import { KontogruppeInfo } from "../../app/apiSlice"

type KontogruppeProp = {
  kontogrupper: KontogruppeInfo[]
}

export default function Kontogruppe({ kontogrupper }: KontogruppeProp): React.ReactElement {
  return (
    <Card className={Styles.kontoer}>
      <div>
        <KontogruppeList kontogruppeInfo={kontogrupper} />
      </div>
    </Card>
  )
}
